// src/services/socket/socketEvents.js - FIXED: Added Missing Backend Events
// 🔧 ISSUE FOUND: Missing events that backend emits but frontend tries to listen for
// 🎯 SOLUTION: Added all missing constants to eliminate "undefined" listeners

export const SOCKET_EVENTS = {
  // ================================
  // CONNECTION EVENTS
  // ================================
  CONNECTION_ESTABLISHED: 'connection_established',
  AUTHENTICATION_FAILED: 'authentication_failed',
  
  // ================================
  // BUSINESS/DASHBOARD EVENTS
  // ================================
  GET_BUSINESS_STATS: 'get_business_stats',
  BUSINESS_STATS_LOADED: 'business_stats_loaded',
  
  // ================================
  // SETTINGS EVENTS
  // ================================
  GET_SETTINGS: 'get_settings',
  SETTINGS_LOADED: 'settings_loaded',
  GET_SETTINGS_FAILED: 'get_settings_failed',
  
  UPDATE_SETTINGS: 'update_settings',
  SETTINGS_UPDATED: 'settings_updated',
  UPDATE_SETTINGS_FAILED: 'update_settings_failed',
  
  GET_BUSINESS_HOURS: 'get_business_hours',
  BUSINESS_HOURS_LOADED: 'business_hours_loaded',
  GET_BUSINESS_HOURS_FAILED: 'get_business_hours_failed',
  
  UPDATE_BUSINESS_HOURS: 'update_business_hours',
  BUSINESS_HOURS_UPDATED: 'business_hours_updated',
  UPDATE_BUSINESS_HOURS_FAILED: 'update_business_hours_failed',
  
  GET_SERVICES: 'get_services',
  SERVICES_LOADED: 'services_loaded',
  GET_SERVICES_FAILED: 'get_services_failed',
  
  CREATE_SERVICE: 'create_service',
  SERVICE_CREATED: 'service_created',
  CREATE_SERVICE_FAILED: 'create_service_failed',
  
  UPDATE_SERVICE: 'update_service',
  SERVICE_UPDATED: 'service_updated',
  UPDATE_SERVICE_FAILED: 'update_service_failed',
  
  DELETE_SERVICE: 'delete_service',
  SERVICE_DELETED: 'service_deleted',
  DELETE_SERVICE_FAILED: 'delete_service_failed',

  GET_NOTIFICATION_PREFERENCES: 'get_notification_preferences',
  NOTIFICATION_PREFERENCES_LOADED: 'notification_preferences_loaded', 
  GET_NOTIFICATION_PREFERENCES_FAILED: 'get_notification_preferences_failed',

  UPDATE_NOTIFICATION_PREFERENCE: 'update_notification_preference',
  NOTIFICATION_PREFERENCE_UPDATED: 'notification_preference_updated',
  UPDATE_NOTIFICATION_PREFERENCE_FAILED: 'update_notification_preference_failed',

  CREATE_DEFAULT_NOTIFICATION_PREFERENCES: 'create_default_notification_preferences',
  DEFAULT_NOTIFICATION_PREFERENCES_CREATED: 'default_notification_preferences_created',
  CREATE_DEFAULT_NOTIFICATION_PREFERENCES_FAILED: 'create_default_notification_preferences_failed',

  SET_ACTIVE_EMAIL_DOMAIN: 'set_active_email_domain',
  SET_BASIC_EMAIL_MODE: 'set_basic_email_mode',

  SET_ACTIVE_EMAIL_DOMAIN_FAILED: 'set_active_email_domain_failed',
  SET_BASIC_EMAIL_MODE_FAILED: 'set_basic_email_mode_failed',

  // ================================
  // EMAIL SETTINGS EVENTS
  // ================================
  GET_EMAIL_SETTINGS: 'get_email_settings',
  EMAIL_SETTINGS_LOADED: 'email_settings_loaded',
  GET_EMAIL_SETTINGS_FAILED: 'get_email_settings_failed',

  UPDATE_EMAIL_SETTINGS: 'update_email_settings',
  EMAIL_SETTINGS_UPDATED: 'email_settings_updated',
  UPDATE_EMAIL_SETTINGS_FAILED: 'update_email_settings_failed',

  SETUP_PROFESSIONAL_DOMAIN: 'setup_professional_domain',
  PROFESSIONAL_DOMAIN_SETUP: 'professional_domain_setup',
  SETUP_PROFESSIONAL_DOMAIN_FAILED: 'setup_professional_domain_failed',

  CHECK_DOMAIN_VERIFICATION: 'check_domain_verification',
  DOMAIN_VERIFICATION_STATUS: 'domain_verification_status',
  CHECK_DOMAIN_VERIFICATION_FAILED: 'check_domain_verification_failed',

  // ================================
  // EMAIL TEMPLATE EVENTS  
  // ================================
  GET_EMAIL_TEMPLATES: 'get_email_templates',
  EMAIL_TEMPLATES_LOADED: 'email_templates_loaded',
  GET_EMAIL_TEMPLATES_FAILED: 'get_email_templates_failed',

  CREATE_EMAIL_TEMPLATE: 'create_email_template',
  EMAIL_TEMPLATE_CREATED: 'email_template_created',
  CREATE_EMAIL_TEMPLATE_FAILED: 'create_email_template_failed',

  UPDATE_EMAIL_TEMPLATE: 'update_email_template',
  EMAIL_TEMPLATE_UPDATED: 'email_template_updated',
  UPDATE_EMAIL_TEMPLATE_FAILED: 'update_email_template_failed',

  DELETE_EMAIL_TEMPLATE: 'delete_email_template',
  EMAIL_TEMPLATE_DELETED: 'email_template_deleted',
  DELETE_EMAIL_TEMPLATE_FAILED: 'delete_email_template_failed',

  // ================================
  // SMS TEMPLATE EVENTS
  // ================================
  GET_SMS_TEMPLATES: 'get_sms_templates',
  SMS_TEMPLATES_LOADED: 'sms_templates_loaded',
  GET_SMS_TEMPLATES_FAILED: 'get_sms_templates_failed',

  CREATE_SMS_TEMPLATE: 'create_sms_template',
  SMS_TEMPLATE_CREATED: 'sms_template_created',
  CREATE_SMS_TEMPLATE_FAILED: 'create_sms_template_failed',

  UPDATE_SMS_TEMPLATE: 'update_sms_template',
  SMS_TEMPLATE_UPDATED: 'sms_template_updated',
  UPDATE_SMS_TEMPLATE_FAILED: 'update_sms_template_failed',

  DELETE_SMS_TEMPLATE: 'delete_sms_template',
  SMS_TEMPLATE_DELETED: 'sms_template_deleted',
  DELETE_SMS_TEMPLATE_FAILED: 'delete_sms_template_failed',

  // ================================
  // TEMPLATE TESTING EVENTS
  // ================================
  TEST_TEMPLATE: 'test_template',
  TEMPLATE_TESTED: 'template_tested',
  TEST_TEMPLATE_FAILED: 'test_template_failed',

  // ================================
  // SERVICE COMPONENT EVENTS
  // ================================
  GET_SERVICE_COMPONENTS: 'get_service_components',
  SERVICE_COMPONENTS_LOADED: 'service_components_loaded',
  GET_SERVICE_COMPONENTS_FAILED: 'get_service_components_failed',
  
  CREATE_SERVICE_COMPONENT: 'create_service_component',
  SERVICE_COMPONENT_CREATED: 'service_component_created',
  CREATE_SERVICE_COMPONENT_FAILED: 'create_service_component_failed',
  
  UPDATE_SERVICE_COMPONENT: 'update_service_component',
  SERVICE_COMPONENT_UPDATED: 'service_component_updated',
  UPDATE_SERVICE_COMPONENT_FAILED: 'update_service_component_failed',
  
  DELETE_SERVICE_COMPONENT: 'delete_service_component',
  SERVICE_COMPONENT_DELETED: 'service_component_deleted',
  DELETE_SERVICE_COMPONENT_FAILED: 'delete_service_component_failed',
  
  // ================================
  // CUSTOMER EVENTS
  // ================================
  GET_CUSTOMERS: 'get_customers',
  CUSTOMERS_LOADED: 'customers_loaded',
  GET_CUSTOMERS_FAILED: 'get_customers_failed',
  
  GET_CUSTOMER_DETAILS: 'get_customer_details',
  CUSTOMER_DETAILS_LOADED: 'customer_details_loaded',
  GET_CUSTOMER_DETAILS_FAILED: 'get_customer_details_failed',
  
  CREATE_CUSTOMER: 'create_customer',
  CUSTOMER_CREATED: 'customer_created',
  CREATE_CUSTOMER_FAILED: 'create_customer_failed',
  
  UPDATE_CUSTOMER: 'update_customer',
  CUSTOMER_UPDATED: 'customer_updated',
  UPDATE_CUSTOMER_FAILED: 'update_customer_failed',
  
  DELETE_CUSTOMER: 'delete_customer',
  CUSTOMER_DELETED: 'customer_deleted',
  DELETE_CUSTOMER_FAILED: 'delete_customer_failed',
  
  SEARCH_CUSTOMERS: 'search_customers',
  CUSTOMERS_SEARCH_RESULTS: 'customers_search_results',
  SEARCH_CUSTOMERS_FAILED: 'search_customers_failed',
  
  // ================================
  // INVOICE EVENTS - 🔧 ADDED MISSING EVENTS
  // ================================
  GET_INVOICES: 'get_invoices',
  INVOICES_LOADED: 'invoices_loaded',
  GET_INVOICES_FAILED: 'get_invoices_failed',
  
  // 🔧 ADDED: Invoice summary events (backend emits these)
  GET_INVOICE_SUMMARY: 'get_invoice_summary',
  INVOICE_SUMMARY_LOADED: 'invoice_summary_loaded',
  GET_INVOICE_SUMMARY_FAILED: 'get_invoice_summary_failed',
  
  GET_INVOICE_DETAILS: 'get_invoice_details',
  INVOICE_DETAILS_LOADED: 'invoice_details_loaded',
  GET_INVOICE_DETAILS_FAILED: 'get_invoice_details_failed',
  
  CREATE_INVOICE: 'create_invoice',
  INVOICE_CREATED: 'invoice_created',
  CREATE_INVOICE_FAILED: 'create_invoice_failed',
  
  UPDATE_INVOICE: 'update_invoice',
  INVOICE_UPDATED: 'invoice_updated',
  UPDATE_INVOICE_FAILED: 'update_invoice_failed',
  
  DELETE_INVOICE: 'delete_invoice',
  INVOICE_DELETED: 'invoice_deleted',
  DELETE_INVOICE_FAILED: 'delete_invoice_failed',
  
  // 🔧 ADDED: Invoice sending events (backend emits these)
  SEND_INVOICE: 'send_invoice',
  INVOICE_SENT: 'invoice_sent',
  SEND_INVOICE_FAILED: 'send_invoice_failed',
  
  // Invoice line items
  ADD_LINE_ITEM: 'add_line_item',
  INVOICE_LINE_ITEM_ADDED: 'invoice_line_item_added',
  ADD_LINE_ITEM_FAILED: 'add_line_item_failed',
  
  UPDATE_LINE_ITEM: 'update_line_item',
  INVOICE_LINE_ITEM_UPDATED: 'invoice_line_item_updated',
  UPDATE_LINE_ITEM_FAILED: 'update_line_item_failed',
  
  REMOVE_LINE_ITEM: 'remove_line_item',
  INVOICE_LINE_ITEM_REMOVED: 'invoice_line_item_removed',
  REMOVE_LINE_ITEM_FAILED: 'remove_line_item_failed',
  
  REORDER_LINE_ITEMS: 'reorder_line_items',
  INVOICE_LINE_ITEMS_REORDERED: 'invoice_line_items_reordered',
  REORDER_LINE_ITEMS_FAILED: 'reorder_line_items_failed',
  
  // Payment events
  MARK_INVOICE_PAID: 'mark_invoice_paid',
  INVOICE_PAYMENT_RECORDED: 'invoice_payment_recorded',
  MARK_INVOICE_PAID_FAILED: 'mark_invoice_paid_failed',
  
  UPDATE_PAYMENT_STATUS: 'update_payment_status',
  PAYMENT_STATUS_UPDATED: 'payment_status_updated',
  UPDATE_PAYMENT_STATUS_FAILED: 'update_payment_status_failed',
  
  // 🔧 ADDED: Invoice payment status update (backend emits this specific event)
  INVOICE_PAYMENT_STATUS_UPDATED: 'invoice_payment_status_updated',

  CREATE_AND_SEND_INVOICE: 'create_and_send_invoice',
  INVOICE_CREATED_AND_SENT: 'invoice_created_and_sent', 
  CREATE_AND_SEND_INVOICE_FAILED: 'create_and_send_invoice_failed',

  // ================================
  // STRIPE CONNECT EVENTS
  // ================================
  
  // Request events (frontend → backend)
  GET_STRIPE_CONNECTION_STATUS: 'get_stripe_connection_status',
  START_EXPRESS_SETUP: 'start_express_setup',
  CREATE_ONBOARDING_LINK: 'create_onboarding_link',
  CHECK_ONBOARDING_STATUS: 'check_onboarding_status',
  REFRESH_STRIPE_CAPABILITIES: 'refresh_stripe_capabilities',
  GET_EXPRESS_DASHBOARD_LINK: 'get_express_dashboard_link',
  DISCONNECT_STRIPE_ACCOUNT: 'disconnect_stripe_account',
  
  // Success events (backend → frontend)
  STRIPE_CONNECTION_STATUS_LOADED: 'stripe_connection_status_loaded',
  STRIPE_ACCOUNT_CREATED: 'stripe_account_created',
  ONBOARDING_LINK_CREATED: 'onboarding_link_created',
  STRIPE_ONBOARDING_STATUS_UPDATED: 'stripe_onboarding_status_updated',
  STRIPE_ACCOUNT_STATUS_UPDATED: 'stripe_account_status_updated',
  STRIPE_CAPABILITIES_REFRESHED: 'stripe_capabilities_refreshed',
  EXPRESS_DASHBOARD_LINK_CREATED: 'express_dashboard_link_created',
  STRIPE_ACCOUNT_DISCONNECTED: 'stripe_account_disconnected',
  
  // Error events (backend → frontend)
  GET_STRIPE_CONNECTION_STATUS_FAILED: 'get_stripe_connection_status_failed',
  START_EXPRESS_SETUP_FAILED: 'start_express_setup_failed',
  CREATE_ONBOARDING_LINK_FAILED: 'create_onboarding_link_failed',
  CHECK_ONBOARDING_STATUS_FAILED: 'check_onboarding_status_failed',
  REFRESH_STRIPE_CAPABILITIES_FAILED: 'refresh_stripe_capabilities_failed',
  GET_EXPRESS_DASHBOARD_LINK_FAILED: 'get_express_dashboard_link_failed',
  DISCONNECT_STRIPE_ACCOUNT_FAILED: 'disconnect_stripe_account_failed',

  // ================================
  // GOOGLE BUSINESS PROFILE (GBP) EVENTS
  // ================================

  // Request events (frontend → backend)
  GET_GBP_CONNECTION_STATUS: 'get_gbp_connection_status',
  START_GBP_OAUTH: 'start_gbp_oauth',
  FETCH_GBP_ACCOUNTS: 'fetch_gbp_accounts',
  FETCH_GBP_LOCATIONS: 'fetch_gbp_locations',
  SAVE_GBP_LOCATIONS: 'save_gbp_locations',
  FETCH_GBP_REVIEWS: 'fetch_gbp_reviews',
  REPLY_TO_GBP_REVIEW: 'reply_to_gbp_review',
  DELETE_GBP_REVIEW_REPLY: 'delete_gbp_review_reply',
  GET_GBP_REVIEW_LINK: 'get_gbp_review_link',
  DISCONNECT_GBP: 'disconnect_gbp',

  // Success events (backend → frontend)
  GBP_CONNECTION_STATUS_LOADED: 'gbp_connection_status_loaded',
  GBP_OAUTH_URL_GENERATED: 'gbp_oauth_url_generated',
  GBP_ACCOUNTS_LOADED: 'gbp_accounts_loaded',
  GBP_LOCATIONS_LOADED: 'gbp_locations_loaded',
  GBP_LOCATIONS_SAVED: 'gbp_locations_saved',
  GBP_REVIEWS_LOADED: 'gbp_reviews_loaded',
  GBP_REVIEW_REPLY_POSTED: 'gbp_review_reply_posted',
  GBP_REVIEW_REPLY_DELETED: 'gbp_review_reply_deleted',
  GBP_REVIEW_LINK_GENERATED: 'gbp_review_link_generated',
  GBP_DISCONNECTED: 'gbp_disconnected',

  // Error events (backend → frontend)
  GET_GBP_CONNECTION_STATUS_FAILED: 'get_gbp_connection_status_failed',
  START_GBP_OAUTH_FAILED: 'start_gbp_oauth_failed',
  FETCH_GBP_ACCOUNTS_FAILED: 'fetch_gbp_accounts_failed',
  FETCH_GBP_LOCATIONS_FAILED: 'fetch_gbp_locations_failed',
  SAVE_GBP_LOCATIONS_FAILED: 'save_gbp_locations_failed',
  FETCH_GBP_REVIEWS_FAILED: 'fetch_gbp_reviews_failed',
  REPLY_TO_GBP_REVIEW_FAILED: 'reply_to_gbp_review_failed',
  DELETE_GBP_REVIEW_REPLY_FAILED: 'delete_gbp_review_reply_failed',
  DISCONNECT_GBP_FAILED: 'disconnect_gbp_failed',

  // ================================
  // EVENT/APPOINTMENT EVENTS
  // ================================
  GET_EVENTS: 'get_events',
  EVENTS_LOADED: 'events_loaded',
  GET_EVENTS_FAILED: 'get_events_failed',
  
  GET_EVENT_DETAILS: 'get_event_details',
  EVENT_DETAILS_LOADED: 'event_details_loaded',
  GET_EVENT_DETAILS_FAILED: 'get_event_details_failed',
  
  CREATE_EVENT: 'create_event',
  EVENT_CREATED: 'event_created',
  CREATE_EVENT_FAILED: 'create_event_failed',
  
  UPDATE_EVENT: 'update_event',
  EVENT_UPDATED: 'event_updated',
  UPDATE_EVENT_FAILED: 'update_event_failed',
  
  DELETE_EVENT: 'delete_event',
  EVENT_DELETED: 'event_deleted',
  DELETE_EVENT_FAILED: 'delete_event_failed',
  
  UPDATE_EVENT_STATUS: 'update_event_status',
  EVENT_STATUS_UPDATED: 'event_status_updated',
  UPDATE_EVENT_STATUS_FAILED: 'update_event_status_failed',
  
  // ================================
  // TEAM EVENTS - 🔧 ADDED MISSING EVENTS
  // ================================
  GET_TEAM_MEMBERS: 'get_team_members',
  TEAM_MEMBERS_LOADED: 'team_members_loaded',
  GET_TEAM_MEMBERS_FAILED: 'get_team_members_failed',
  
  CHECK_PERMISSIONS: 'check_permissions',
  PERMISSIONS_LOADED: 'permissions_loaded',
  CHECK_PERMISSIONS_FAILED: 'check_permissions_failed',
  
  GET_TEAM_ACTIVITY: 'get_team_activity',
  TEAM_ACTIVITY_LOADED: 'team_activity_loaded',
  GET_TEAM_ACTIVITY_FAILED: 'get_team_activity_failed',
  
  INVITE_TEAM_MEMBER: 'invite_team_member',
  TEAM_MEMBER_INVITED: 'team_member_invited',
  INVITE_TEAM_MEMBER_FAILED: 'invite_team_member_failed',
  
  // 🔧 FIXED: Backend uses 'update_team_member_role' not 'update_member_role'
  UPDATE_TEAM_MEMBER_ROLE: 'update_team_member_role',
  TEAM_MEMBER_ROLE_UPDATED: 'team_member_role_updated',
  UPDATE_TEAM_MEMBER_ROLE_FAILED: 'update_team_member_role_failed',
  
  // 🔧 ADDED: Role change notification (backend emits this to affected user)
  ROLE_CHANGED: 'role_changed',
  
  REMOVE_TEAM_MEMBER: 'remove_team_member',
  TEAM_MEMBER_REMOVED: 'team_member_removed',
  REMOVE_TEAM_MEMBER_FAILED: 'remove_team_member_failed',

  REACTIVATE_TEAM_MEMBER: 'reactivate_team_member',
  TEAM_MEMBER_REACTIVATED: 'team_member_reactivated',
  REACTIVATE_TEAM_MEMBER_FAILED: 'reactivate_team_member_failed',

  GET_PENDING_INVITATIONS: 'get_pending_invitations',
  PENDING_INVITATIONS_LOADED: 'pending_invitations_loaded', 
  GET_PENDING_INVITATIONS_FAILED: 'get_pending_invitations_failed',

  CANCEL_TEAM_INVITATION: 'cancel_team_invitation',
  TEAM_INVITATION_CANCELLED: 'team_invitation_cancelled',
  CANCEL_TEAM_INVITATION_FAILED: 'cancel_team_invitation_failed',

  RESEND_TEAM_INVITATION: 'resend_team_invitation', 
  TEAM_INVITATION_RESENT: 'team_invitation_resent',
  RESEND_TEAM_INVITATION_FAILED: 'resend_team_invitation_failed',
  
  // ================================
  // PARTNER EVENTS
  // ================================
  // Partner Network Management
  GET_PARTNER_NETWORK: 'get_partner_network',
  PARTNER_NETWORK_LOADED: 'partner_network_loaded',
  GET_PARTNER_NETWORK_FAILED: 'get_partner_network_failed',
  
  UPDATE_NETWORK_PROFILE: 'update_network_profile',
  NETWORK_PROFILE_UPDATED: 'network_profile_updated',
  UPDATE_NETWORK_PROFILE_FAILED: 'update_network_profile_failed',
  
  // Business Discovery
  SEARCH_PARTNER_BUSINESSES: 'search_partner_businesses',
  PARTNER_SEARCH_RESULTS: 'partner_search_results',
  SEARCH_PARTNER_BUSINESSES_FAILED: 'search_partner_businesses_failed',
  
  // Connection Management
  SEND_CONNECTION_REQUEST: 'send_connection_request',
  CONNECTION_REQUEST_SENT: 'connection_request_sent',
  CONNECTION_REQUEST_RECEIVED: 'connection_request_received',
  SEND_CONNECTION_REQUEST_FAILED: 'send_connection_request_failed',
  
  RESPOND_TO_CONNECTION_REQUEST: 'respond_to_connection_request',
  CONNECTION_REQUEST_RESPONSE: 'connection_request_response',
  RESPOND_TO_CONNECTION_REQUEST_FAILED: 'respond_to_connection_request_failed',
  
  // Referral Collaborations
  GET_REFERRAL_COLLABORATIONS: 'get_referral_collaborations',
  REFERRAL_COLLABORATIONS_LOADED: 'referral_collaborations_loaded',
  GET_REFERRAL_COLLABORATIONS_FAILED: 'get_referral_collaborations_failed',
  
  ADD_REFERRAL_NOTE: 'add_referral_note',
  REFERRAL_NOTE_ADDED: 'referral_note_added',
  ADD_REFERRAL_NOTE_FAILED: 'add_referral_note_failed',
  
  REFERRAL_STATUS_UPDATED: 'referral_status_updated',
  
  // Partner Availability
  GET_PARTNER_AVAILABILITY: 'get_partner_availability',
  PARTNER_AVAILABILITY_LOADED: 'partner_availability_loaded',
  GET_PARTNER_AVAILABILITY_FAILED: 'get_partner_availability_failed',

  // Partner Services
  GET_PARTNER_SERVICES: 'get_partner_services',
  PARTNER_SERVICES_LOADED: 'partner_services_loaded', 
  GET_PARTNER_SERVICES_FAILED: 'get_partner_services_failed',

  // Partner Collab
  PARTNER_COLLABORATION_CREATED: 'partner_collaboration_created',
  CREATE_PARTNER_SERVICE: 'create_partner_service',
  PARTNER_SERVICE_CREATED: 'partner_service_created',
  CREATE_PARTNER_SERVICE_FAILED: 'create_partner_service_failed',

  // ================================
  // WIDGET EVENTS
  // ================================
  GET_WIDGETS: 'get_widgets',
  WIDGETS_LOADED: 'widgets_loaded',
  GET_WIDGETS_FAILED: 'get_widgets_failed',

  GET_WIDGET_DETAILS: 'get_widget_details',
  WIDGET_DETAILS_LOADED: 'widget_details_loaded',
  GET_WIDGET_DETAILS_FAILED: 'get_widget_details_failed',

  CREATE_WIDGET: 'create_widget',
  WIDGET_CREATED: 'widget_created',
  CREATE_WIDGET_FAILED: 'create_widget_failed',

  UPDATE_WIDGET: 'update_widget',
  WIDGET_UPDATED: 'widget_updated',
  UPDATE_WIDGET_FAILED: 'update_widget_failed',

  PUBLISH_WIDGET: 'publish_widget',
  WIDGET_PUBLISHED: 'widget_published',
  PUBLISH_WIDGET_FAILED: 'publish_widget_failed',

  TOGGLE_WIDGET_STATUS: 'toggle_widget_status',
  WIDGET_STATUS_TOGGLED: 'widget_status_toggled',
  TOGGLE_WIDGET_STATUS_FAILED: 'toggle_widget_status_failed',

  DELETE_WIDGET: 'delete_widget',
  WIDGET_DELETED: 'widget_deleted',
  DELETE_WIDGET_FAILED: 'delete_widget_failed',

  GET_EMBED_CODE: 'get_embed_code',
  EMBED_CODE_GENERATED: 'embed_code_generated',
  GET_EMBED_CODE_FAILED: 'get_embed_code_failed',

  // ================================
  // JOB NOTES EVENTS
  // ================================
  
  // Request events (frontend → backend)
  GET_JOB_NOTES: 'get_job_notes',
  CREATE_JOB_NOTE: 'create_job_note',
  UPDATE_JOB_NOTE: 'update_job_note',
  DELETE_JOB_NOTE: 'delete_job_note',
  
  // Success events (backend → frontend)
  JOB_NOTES_LOADED: 'job_notes_loaded',
  JOB_NOTE_CREATED: 'job_note_created',
  JOB_NOTE_UPDATED: 'job_note_updated',
  JOB_NOTE_DELETED: 'job_note_deleted',
  
  // Error events (backend → frontend)
  GET_JOB_NOTES_FAILED: 'get_job_notes_failed',
  CREATE_JOB_NOTE_FAILED: 'create_job_note_failed',
  UPDATE_JOB_NOTE_FAILED: 'update_job_note_failed',
  DELETE_JOB_NOTE_FAILED: 'delete_job_note_failed',
  
  // ================================
  // PIPELINE MANAGEMENT EVENTS
  // ================================

  // Pipeline CRUD
  GET_PIPELINES: 'get_pipelines',
  PIPELINES_LIST: 'pipelines_list',

  GET_PIPELINE: 'get_pipeline',
  PIPELINE_DETAILS: 'pipeline_details',

  CREATE_PIPELINE: 'create_pipeline',
  PIPELINE_CREATED: 'pipeline_created',
  CREATE_PIPELINE_FAILED: 'create_pipeline_failed',

  UPDATE_PIPELINE: 'update_pipeline',
  PIPELINE_UPDATED: 'pipeline_updated',
  UPDATE_PIPELINE_FAILED: 'update_pipeline_failed',

  DELETE_PIPELINE: 'delete_pipeline',
  PIPELINE_DELETED: 'pipeline_deleted',
  DELETE_PIPELINE_FAILED: 'delete_pipeline_failed',

  TOGGLE_PIPELINE_STATUS: 'toggle_pipeline_status',
  PIPELINE_STATUS_TOGGLED: 'pipeline_status_toggled',
  TOGGLE_PIPELINE_STATUS_FAILED: 'toggle_pipeline_status_failed',

  // Stage Management
  GET_STAGES: 'get_stages',
  STAGES_LIST: 'stages_list',
  GET_STAGES_FAILED: 'get_stages_failed',

  GET_STAGE: 'get_stage',
  STAGE_DETAILS: 'stage_details',
  GET_STAGE_FAILED: 'get_stage_failed',

  CREATE_STAGE: 'create_stage',
  STAGE_CREATED: 'stage_created',
  CREATE_STAGE_FAILED: 'create_stage_failed',

  UPDATE_STAGE: 'update_stage',
  STAGE_UPDATED: 'stage_updated',
  UPDATE_STAGE_FAILED: 'update_stage_failed',

  DELETE_STAGE: 'delete_stage',
  STAGE_DELETED: 'stage_deleted',
  DELETE_STAGE_FAILED: 'delete_stage_failed',

  REORDER_STAGES: 'reorder_stages',
  STAGES_REORDERED: 'stages_reordered',
  REORDER_STAGES_FAILED: 'reorder_stages_failed',

  // Automation Rule Management
  GET_RULES: 'get_rules',
  RULES_LIST: 'rules_list',
  GET_RULES_FAILED: 'get_rules_failed',

  GET_RULE: 'get_rule',
  RULE_DETAILS: 'rule_details',
  GET_RULE_FAILED: 'get_rule_failed',

  CREATE_RULE: 'create_rule',
  RULE_CREATED: 'rule_created',
  CREATE_RULE_FAILED: 'create_rule_failed',

  UPDATE_RULE: 'update_rule',
  RULE_UPDATED: 'rule_updated',
  UPDATE_RULE_FAILED: 'update_rule_failed',

  DELETE_RULE: 'delete_rule',
  RULE_DELETED: 'rule_deleted',
  DELETE_RULE_FAILED: 'delete_rule_failed',

  TOGGLE_RULE_STATUS: 'toggle_rule_status',
  RULE_STATUS_TOGGLED: 'rule_status_toggled',
  TOGGLE_RULE_STATUS_FAILED: 'toggle_rule_status_failed',

  // Pipeline Items (Kanban/Customer Management)
  GET_PIPELINE_BOARD: 'get_pipeline_board',
  PIPELINE_BOARD_DATA: 'pipeline_board_data',
  GET_PIPELINE_BOARD_FAILED: 'get_pipeline_board_failed',

  ADD_CUSTOMER_TO_PIPELINE: 'add_customer_to_pipeline',
  CUSTOMER_ADDED_TO_PIPELINE: 'customer_added_to_pipeline',
  ADD_CUSTOMER_TO_PIPELINE_FAILED: 'add_customer_to_pipeline_failed',

  MOVE_CUSTOMER_TO_STAGE: 'move_customer_to_stage',
  CUSTOMER_MOVED_TO_STAGE: 'customer_moved_to_stage',
  MOVE_CUSTOMER_TO_STAGE_FAILED: 'move_customer_to_stage_failed',

  REMOVE_CUSTOMER_FROM_PIPELINE: 'remove_customer_from_pipeline',
  CUSTOMER_REMOVED_FROM_PIPELINE: 'customer_removed_from_pipeline',
  REMOVE_CUSTOMER_FROM_PIPELINE_FAILED: 'remove_customer_from_pipeline_failed',

  GET_STAGE_ITEMS: 'get_stage_items',
  STAGE_ITEMS_LIST: 'stage_items_list',
  GET_STAGE_ITEMS_FAILED: 'get_stage_items_failed',

  GET_CUSTOMER_PIPELINE_STATUS: 'get_customer_pipeline_status',
  CUSTOMER_PIPELINE_STATUS: 'customer_pipeline_status',
  GET_CUSTOMER_PIPELINE_STATUS_FAILED: 'get_customer_pipeline_status_failed',

  // Automation Flow Management
  GET_AUTOMATION_FLOWS: 'get_automation_flows',
  AUTOMATION_FLOWS_LIST: 'automation_flows_list',
  GET_AUTOMATION_FLOWS_FAILED: 'get_automation_flows_failed',

  GET_AUTOMATION_FLOW: 'get_automation_flow',
  AUTOMATION_FLOW_DETAILS: 'automation_flow_details',
  GET_AUTOMATION_FLOW_FAILED: 'get_automation_flow_failed',

  CREATE_AUTOMATION_FLOW: 'create_automation_flow',
  AUTOMATION_FLOW_CREATED: 'automation_flow_created',
  CREATE_AUTOMATION_FLOW_FAILED: 'create_automation_flow_failed',

  UPDATE_AUTOMATION_FLOW: 'update_automation_flow',
  AUTOMATION_FLOW_UPDATED: 'automation_flow_updated',
  UPDATE_AUTOMATION_FLOW_FAILED: 'update_automation_flow_failed',

  DELETE_AUTOMATION_FLOW: 'delete_automation_flow',
  AUTOMATION_FLOW_DELETED: 'automation_flow_deleted',
  DELETE_AUTOMATION_FLOW_FAILED: 'delete_automation_flow_failed',

  // ================================
  // ERROR EVENTS (Generic)
  // ================================
  ERROR: 'error',
  AUTHENTICATION_ERROR: 'authentication_error',
  AUTHORIZATION_FAILED: 'authorization_failed',
  VALIDATION_ERROR: 'validation_error',
  SERVER_ERROR: 'server_error'
};

// Helper functions for event names
export const EVENT_HELPERS = {
  /**
   * Check if an event is an error event
   */
  isErrorEvent(eventName) {
    return eventName.includes('_failed') || 
           eventName.includes('_error') || 
           eventName === SOCKET_EVENTS.ERROR;
  },
  
  /**
   * Check if an event is a success response
   */
  isSuccessEvent(eventName) {
    return eventName.includes('_loaded') || 
           eventName.includes('_created') || 
           eventName.includes('_updated') || 
           eventName.includes('_deleted') ||
           eventName.includes('_sent') ||
           eventName.includes('_processed');
  },
  
  /**
   * Get the corresponding success event for a request
   */
  getSuccessEvent(requestEvent) {
    const successMap = {
      [SOCKET_EVENTS.GET_CUSTOMERS]: SOCKET_EVENTS.CUSTOMERS_LOADED,
      [SOCKET_EVENTS.CREATE_CUSTOMER]: SOCKET_EVENTS.CUSTOMER_CREATED,
      [SOCKET_EVENTS.UPDATE_CUSTOMER]: SOCKET_EVENTS.CUSTOMER_UPDATED,
      [SOCKET_EVENTS.GET_INVOICES]: SOCKET_EVENTS.INVOICES_LOADED,
      [SOCKET_EVENTS.CREATE_INVOICE]: SOCKET_EVENTS.INVOICE_CREATED,
      [SOCKET_EVENTS.GET_SETTINGS]: SOCKET_EVENTS.SETTINGS_LOADED,
      [SOCKET_EVENTS.UPDATE_SETTING]: SOCKET_EVENTS.SETTING_UPDATED,
      [SOCKET_EVENTS.GET_TEAM_MEMBERS]: SOCKET_EVENTS.TEAM_MEMBERS_LOADED,
      [SOCKET_EVENTS.GET_PARTNER_NETWORK]: SOCKET_EVENTS.PARTNER_NETWORK_LOADED,
      [SOCKET_EVENTS.SEARCH_CUSTOMERS]: SOCKET_EVENTS.CUSTOMERS_SEARCH_RESULTS,
      [SOCKET_EVENTS.GET_EMAIL_TEMPLATES]: SOCKET_EVENTS.EMAIL_TEMPLATES_LOADED,
      [SOCKET_EVENTS.CREATE_EMAIL_TEMPLATE]: SOCKET_EVENTS.EMAIL_TEMPLATE_CREATED,
      [SOCKET_EVENTS.UPDATE_EMAIL_TEMPLATE]: SOCKET_EVENTS.EMAIL_TEMPLATE_UPDATED,
      [SOCKET_EVENTS.DELETE_EMAIL_TEMPLATE]: SOCKET_EVENTS.EMAIL_TEMPLATE_DELETED,
      [SOCKET_EVENTS.GET_SMS_TEMPLATES]: SOCKET_EVENTS.SMS_TEMPLATES_LOADED,
      [SOCKET_EVENTS.CREATE_SMS_TEMPLATE]: SOCKET_EVENTS.SMS_TEMPLATE_CREATED,
      [SOCKET_EVENTS.UPDATE_SMS_TEMPLATE]: SOCKET_EVENTS.SMS_TEMPLATE_UPDATED,
      [SOCKET_EVENTS.DELETE_SMS_TEMPLATE]: SOCKET_EVENTS.SMS_TEMPLATE_DELETED,
      [SOCKET_EVENTS.TEST_TEMPLATE]: SOCKET_EVENTS.TEMPLATE_TESTED,
      [SOCKET_EVENTS.GET_JOB_NOTES]: SOCKET_EVENTS.JOB_NOTES_LOADED,
      [SOCKET_EVENTS.CREATE_JOB_NOTE]: SOCKET_EVENTS.JOB_NOTE_CREATED,
      [SOCKET_EVENTS.UPDATE_JOB_NOTE]: SOCKET_EVENTS.JOB_NOTE_UPDATED,
      [SOCKET_EVENTS.DELETE_JOB_NOTE]: SOCKET_EVENTS.JOB_NOTE_DELETED,
    };
    
    return successMap[requestEvent];
  },
  
  /**
   * Get the corresponding error event for a request
   */
  getErrorEvent(requestEvent) {
    const errorMap = {
      [SOCKET_EVENTS.GET_CUSTOMERS]: SOCKET_EVENTS.GET_CUSTOMERS_FAILED,
      [SOCKET_EVENTS.CREATE_CUSTOMER]: SOCKET_EVENTS.CREATE_CUSTOMER_FAILED,
      [SOCKET_EVENTS.UPDATE_CUSTOMER]: SOCKET_EVENTS.UPDATE_CUSTOMER_FAILED,
      [SOCKET_EVENTS.GET_INVOICES]: SOCKET_EVENTS.GET_INVOICES_FAILED,
      [SOCKET_EVENTS.CREATE_INVOICE]: SOCKET_EVENTS.CREATE_INVOICE_FAILED,
      [SOCKET_EVENTS.UPDATE_SETTING]: SOCKET_EVENTS.UPDATE_SETTING_FAILED,
      [SOCKET_EVENTS.GET_TEAM_MEMBERS]: SOCKET_EVENTS.GET_TEAM_MEMBERS_FAILED,
      [SOCKET_EVENTS.GET_PARTNER_NETWORK]: SOCKET_EVENTS.GET_PARTNER_NETWORK_FAILED,
      [SOCKET_EVENTS.SEARCH_CUSTOMERS]: SOCKET_EVENTS.SEARCH_CUSTOMERS_FAILED,
      [SOCKET_EVENTS.GET_EMAIL_TEMPLATES]: SOCKET_EVENTS.GET_EMAIL_TEMPLATES_FAILED,
      [SOCKET_EVENTS.CREATE_EMAIL_TEMPLATE]: SOCKET_EVENTS.CREATE_EMAIL_TEMPLATE_FAILED,
      [SOCKET_EVENTS.UPDATE_EMAIL_TEMPLATE]: SOCKET_EVENTS.UPDATE_EMAIL_TEMPLATE_FAILED,
      [SOCKET_EVENTS.DELETE_EMAIL_TEMPLATE]: SOCKET_EVENTS.DELETE_EMAIL_TEMPLATE_FAILED,
      [SOCKET_EVENTS.GET_SMS_TEMPLATES]: SOCKET_EVENTS.GET_SMS_TEMPLATES_FAILED,
      [SOCKET_EVENTS.CREATE_SMS_TEMPLATE]: SOCKET_EVENTS.CREATE_SMS_TEMPLATE_FAILED,
      [SOCKET_EVENTS.UPDATE_SMS_TEMPLATE]: SOCKET_EVENTS.UPDATE_SMS_TEMPLATE_FAILED,
      [SOCKET_EVENTS.DELETE_SMS_TEMPLATE]: SOCKET_EVENTS.DELETE_SMS_TEMPLATE_FAILED,
      [SOCKET_EVENTS.TEST_TEMPLATE]: SOCKET_EVENTS.TEST_TEMPLATE_FAILED,
      [SOCKET_EVENTS.GET_JOB_NOTES]: SOCKET_EVENTS.GET_JOB_NOTES_FAILED,
      [SOCKET_EVENTS.CREATE_JOB_NOTE]: SOCKET_EVENTS.CREATE_JOB_NOTE_FAILED,
      [SOCKET_EVENTS.UPDATE_JOB_NOTE]: SOCKET_EVENTS.UPDATE_JOB_NOTE_FAILED,
      [SOCKET_EVENTS.DELETE_JOB_NOTE]: SOCKET_EVENTS.DELETE_JOB_NOTE_FAILED,
    };
    
    return errorMap[requestEvent];
  }
};

export default SOCKET_EVENTS;